import { Controller } from "@hotwired/stimulus"

// The main content is a nested scroll container, so Turbo's built-in scroll
// restoration (which only covers the window) never reaches it. Remember each
// URL's scroll position and put the user back where they were on return —
// whether they use the browser back button or an in-app "back" link.
export default class extends Controller {
  connect() {
    // Capture this page's key at mount time. By the time `turbo:before-cache`
    // fires, Turbo has already advanced window.location to the destination, so
    // reading it at save time would let an outgoing page save its scrollTop
    // under the *next* page's key — clobbering that page's real position (e.g.
    // an edit page that shares the standard layout wiping its list's scroll).
    this.storageKey = `scroll:${window.location.pathname}${window.location.search}`
    this.save = this.save.bind(this)
    this.onScroll = this.onScroll.bind(this)
    document.addEventListener("turbo:before-cache", this.save)
    this.element.addEventListener("scroll", this.onScroll, { passive: true })
    this.restore()
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.save)
    this.element.removeEventListener("scroll", this.onScroll)
  }

  // Persist continuously (throttled to one write per frame) so the latest
  // position is always stored, independent of Turbo's navigation lifecycle.
  onScroll() {
    if (this.ticking) return
    this.ticking = true
    requestAnimationFrame(() => {
      this.save()
      this.ticking = false
    })
  }

  save() {
    sessionStorage.setItem(this.storageKey, this.element.scrollTop)
  }

  restore() {
    const y = sessionStorage.getItem(this.storageKey)
    if (y !== null) this.element.scrollTop = parseInt(y, 10)
  }
}
